import React, { useState, useEffect } from 'react'
import {
  Autocomplete as MUIAutocomplete,
  TextField as MuiTextField,
  ThemeProvider,
} from '@mui/material'
import { theme } from '../../../muiTheme'
import { Controller } from 'react-hook-form'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export const Autocomplete = ({
  name,
  label,
  options,
  control,
  error,
  onInputChange,
  noOptionsText = 'No options',
  onSearchingText = 'Searching...',
  disableSearch = false,
  onFocus,
  onBlur,
  open,
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState('')

  const getNoOptionsText = () => {
    return inputValue.length < 3 ? noOptionsText : onSearchingText
  }

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value, ref } }) => (
            <MUIAutocomplete
              fullWidth
              options={options}
              open={open}
              popupIcon={
                <ExpandMoreIcon
                  sx={{
                    color: disabled ? '#ccc' : '#002677',
                    fontSize: '24px',
                  }}
                />
              }
              getOptionLabel={(option) => option.text}
              getOptionKey={(option) => option.value}
              value={value || null}
              onInputChange={(_, inputValue) => {
                setInputValue(inputValue)
                onInputChange(inputValue)
              }}
              {...(disableSearch && { filterOptions: (options) => options })}
              noOptionsText={getNoOptionsText()}
              onChange={(_, newValue) => {
                onChange(newValue)
              }}
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              }
              {...(onFocus && { onFocus })}
              {...(onBlur && { onBlur })}
              disabled={disabled}
              renderInput={(params) => (
                <MuiTextField
                  variant="filled"
                  label={label}
                  inputRef={ref}
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password', // 👈 Prevent browser autofill
                  }}
                  sx={{
                    '& .Mui-disabled': {
                      cursor: 'not-allowed',
                    },
                    '& .Mui-disabled::before': {
                      borderBottom: 'none !important',
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                      backgroundColor: '#f9f9f9',
                      cursor: 'not-allowed',
                    },
                    '& .MuiInputLabel-root.Mui-disabled': {
                      color: '#002677',
                    },
                    '& .MuiFilledInput-input.Mui-disabled': {
                      WebkitTextFillColor: '#666666',
                    },
                  }}
                />
              )}
            />
          )}
        />
        {error && (
          <span className="field-validation-error error pb-0">
            {error.message}
          </span>
        )}
      </div>
    </ThemeProvider>
  )
}
